module.exports = __webpack_public_path__ + "assets/StudentVHITemplate-c0bc8ace09c39fe1f9841afa7d662821.xlsx";